module.exports = __webpack_public_path__ + "static/media/chevron-up.49988e65.svg";